<template>
    <GuideStep3Component
        type="POPUP"
        :step="props.step"
        :content="$t('guide.guide_popover_step_6_desc')"
        :buttonText="$t('guide.guide_popover_step_6_btn_create')"
        :templateTitle="$t('experience.common.popup_template_title')"
        componentName="ExperienceTemplate"
    ></GuideStep3Component>
</template>

<script lang="ts" setup>
import GuideStep3Component from './GuideStep3Component.vue';
import { GuideStep } from '@master/store/guide.store';

interface Props {
    step: GuideStep;
}

const props = defineProps<Props>();
</script>

<style lang="scss" module>
@import '@style/import.scss';
</style>
